<template>
  <div id="BrowseLayout">
    <DefaultNavbar />
    <div class="BrowseLayout-body">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="search-panel">
              <div class="search-panel-body">
                <!-- <div class="input-group input-group-sm mb-3">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:placeholder="$t('browse_now.placeholder_search')"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    v-model="searchText"
                    @change="updateSearchText"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2"><i class="fas fa-search"></i></span>
                  </div>
                </div> -->

                <div class="input-group">
                  <input type="text"
                    class="search mb-3"
                    v-bind:placeholder="$t('browse_now.placeholder_search')"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    v-model="searchText"
                    @change="updateSearchText"
                  />
                  <a id="basic-addon2" @click="updateSearchText"><i class="fas fa-search icon-seach"></i></a>
                </div>


                <div class="text-secondary font-weight-bold mb-2 title-categories">{{$t('browse_now.categories')}}</div>
                <div v-if="categories.loading">loading</div>
                    <swiper  class="swiperCategories " :options="swiperCategories" >
                        <swiper-slide v-for="(cat) in categories.data" :key="cat._id" >
                            <ul class="nav flex-column">
                                <li :title="cat.name" v-on:click="selectedCategory = cat._id">
                                    <div class="d-flex flex-column flex-lg-row d-inline-block effect-hover">
                                        <img class="rounded bg-light mt-2 mb-1 mr-2" width="50px"  height="50px"  :src="cat.logo" alt="lỗi"/>
                                        <div class="d-flex align-items-center" :class="{active: cat._id === selectedCategory}" >
                                            <span>
                                            {{ cat.name | add3Dot }}
                                            <span class="total-provider text-white d-none d-lg-block">{{ cat.totalProvider}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </li> 
                            </ul>
                        </swiper-slide> 
                    </swiper>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <DefaultFooter />
  </div>
</template>

<style lang="scss" scoped>
.BrowseLayout-body {
  padding: 20px 0 50px;

}
.effect-hover:hover{
  font-weight: bold;
  cursor: pointer;
}
.title-categories{
  font-size: 1rem;
}
.input-group{
  // background-color: #ffffff;
  // border-left: 0px;
  // color: #000000;
  position: relative;
  .search{
    font-family: "Open Sans";
    font-size: 14px;
    line-height: 19px;
    color: black;
    height: 40px;
    width: 100%;
    border-radius: 8px;
    border: none;
    outline: none;
    padding: 0px 10px;
    margin: 5px 0px 5px 0px;
  }
  #basic-addon2{
    position: absolute;
    right: 0px;
    top: 5px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover, .icon-seach{
      opacity: 0.8;
    }
    .icon-seach{
      font-size: 18px;
    }
  }
}

.search-panel {
  position: relative;
  &::before {
    content: "";
    background-color: #ffbe17;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: -999px;
    border-radius: 20px;
  }
  .search-panel-body {
    position: relative;
    padding: 20px 15px;
  }
  .active{
    color: black;
    font-weight: bold;
  }
}
@media screen and (min-width: 992px){
  .swiperCategories{
    width: 100%;
    // height: 450px;
  }
}
</style>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapState, mapActions } from "vuex";
import DefaultFooter from "@/components/DefaultFooter.vue";
import DefaultNavbar from "@/components/DefaultNavbar.vue";

export default {
  name: "BrowseLayout",
  components: {
    DefaultFooter,
    DefaultNavbar,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      searchText: this.$store.state.providerFilters.searchText,
      swiperCategories:{
        // autoWidth: true,
        // freeMode: true,
        // centeredSlides: true,
        // direction: 'vertical',
        // mouseWheel: true,
        breakpoints:{
          1200: {
              direction: 'vertical',
              slidesPerView: "auto",
              spaceBetween: 5,
              simulateTouch:false, 
              allowTouchMove: false,
          },
          992:{
              direction: 'vertical',
              slidesPerView: "auto",
              spaceBetween: 5,
              simulateTouch:false, 
              allowTouchMove: false,
          },
          768:{
              direction: 'horizontal',
              slidesPerView: 6,
              spaceBetween: 5,
              simulateTouch: true, 
              allowTouchMove: true
          },
          576:{
              direction: 'horizontal',
              slidesPerView: 5,
              spaceBetween: 5,
              simulateTouch: true, 
              allowTouchMove: true
          },
          320: {
              direction: 'horizontal',
              slidesPerView: 4,
              spaceBetween: 50,
              simulateTouch: true, 
              allowTouchMove: true              
          }
        }
      }
    };
  },
  filters:{
      add3Dot(text, limit = 25) {
        var dots = "...";
        if (text.length > limit)
        {
            text = text.substring(0, limit) + dots;
        }
        return text;
      }  
  },
  computed: {
    ...mapState(["categories"]),
    selectedCategory: {
      get() {
        // return this.$store.state.providerFilters.categoryIds[0] ? this.$store.state.providerFilters.categoryIds[0] : this.categories.data[0]._id; // we only suport 1 for now
        return this.$store.state.providerFilters.categoryIds[0]; // we only suport 1 for now
      },
      set(value) {
        // const stateCategory = this.$store.state.providerFilters.categoryIds[0];
        // if (stateCategory == value) {
        //   return;
        // }
        this.$router.push('/browse/search');
        this.$nextTick(()=>{
           this.$forceUpdate();
           this.$store.commit("providerFilters", { categoryIds: [value] }); // we only suport 1 for now
        })
      }
    }
  },
  methods: {
    ...mapActions(["loadCategories"]),
    updateSearchText() {
      this.$store.commit("providerFilters", { searchText: this.searchText });
    },
  },
  mounted() {
    this.loadCategories({language: 'vi'});
  }
};
</script>
